






import Vue, { PropType } from "vue";
import ParkSite from "../../../shared/ParkSite";
import { TextValue } from "../../../shared/TextValue";

export default Vue.extend({
  name: "ClientFilter",
  props: {
    value: String,
    SelectedFilterCountry: String,
    ParkSitesList: {
      type: Array as PropType<ParkSite[]>,
    },
  },
  computed: {
    computedValue: {
      get(): string {
        return this.value;
      },
      set() {
        // do nothing
      },
    },
  },
  methods: {
    handleInput(value: string): void {
      this.$emit("input", value);
    },
    FilterCouncils(): TextValue[] {
      const dict: { [id: string]: boolean } = {};
      for (const parksite of this.ParkSitesList) {
        if (
          this.SelectedFilterCountry &&
          this.SelectedFilterCountry !== parksite.country
        ) {
          continue;
        }
        if (parksite.council) {
          dict[parksite.council] = true;
        }
      }

      const result: TextValue[] = [];
      result.push({ text: "Any", value: "", disabled: false });
      for (const key of Object.keys(dict).sort()) {
        result.push({ text: key, value: key, disabled: false });
      }
      return result;
    },
  },
});
